<template>
	<pre v-html="$t('terms.guideline2')"></pre>
</template>

<script>
export default {
	name: 'Guideline2',
};
</script>

<style scoped></style>
